"use client";
import { useDirection } from "../../../core/DirectionProvider/DirectionProvider.mjs";
import { getArrowPositionStyles } from "./get-arrow-position-styles.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/utils/Floating/FloatingArrow/FloatingArrow.tsx
function FloatingArrow({ position, arrowSize, arrowOffset, arrowRadius, arrowPosition, visible, arrowX, arrowY, style, ...others }) {
	const { dir } = useDirection();
	if (!visible) return null;
	return /* @__PURE__ */ jsx("div", {
		role: "presentation",
		...others,
		style: {
			...style,
			...getArrowPositionStyles({
				position,
				arrowSize,
				arrowOffset,
				arrowRadius,
				arrowPosition,
				dir,
				arrowX,
				arrowY
			})
		}
	});
}
FloatingArrow.displayName = "@mantine/core/FloatingArrow";
//#endregion
export { FloatingArrow };

//# sourceMappingURL=FloatingArrow.mjs.map